import { ContactForm, ContactInfo, ContactHeading } from "@/components/contact/ContactParts";
import { SectionLabel, FadeUp } from "@/components/site/motion";
import { CONTACT } from "@/lib/content";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="relative">
      <section className="relative overflow-hidden pt-36 md:pt-44">
        <div className="hex-pattern pointer-events-none absolute inset-0 opacity-40" />
        <div className="relative mx-auto max-w-[1440px] px-6 md:px-10"><ContactHeading /></div>
      </section>
      <section className="py-20 md:pb-32 md:pt-28">
        <div className="mx-auto grid max-w-[1440px] gap-10 px-6 md:px-10 lg:grid-cols-12">
          <FadeUp className="min-w-0 lg:col-span-7"><ContactForm /></FadeUp>
          <div className="min-w-0 lg:col-span-5">
            <SectionLabel>Reach us directly</SectionLabel>
            <div className="mt-6"><ContactInfo contact={CONTACT} /></div>
            <div className="mt-10">
              <SectionLabel>Follow</SectionLabel>
              <div className="mt-5 grid grid-cols-2 gap-3">
                {CONTACT.socials.map((s) => (
                  <a key={s.label} href={s.href} data-testid={`contact-social-${s.label.split(" ")[0].toLowerCase()}`}
                    className="rounded-full border border-cream/15 px-5 py-3 text-center font-body text-sm text-cream/85 transition-colors duration-300 hover:bg-cream hover:text-skaris-ink">
                    {s.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
